import {useParams} from 'react-router-dom'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../parts/crud/List'
import {ColumnType, FilterType} from '../../../parts/crud/Types'
import {useEffect, useState} from 'react'
import {processGet} from '../../../../services/api'


export const ListLogs = () => {
  const {id} = useParams()
  const [userName, setUserName] = useState("") 
  const [userUsername, setUserUsername] = useState("")
  let api = 'users/' + id+"/logs"
  useEffect(() => {
    const fetchUser = async () => {
      let user:any = await processGet('users/' + id)
      setUserName(user.data.name);
      setUserUsername(user.data.email);
    }
    fetchUser()
  }, [id])
  const filters: Array<FilterType> = [
    {
      title: 'Da',
      key: 'date_from',
      type: 'date',
    },
    {
      title: 'A',
      key: 'date_to',
      type: 'date',
    },
  ]

  //IP	Dati sessione	User Agent	OS	Data accesso
  const columns: Array<ColumnType>  = [
    {title: 'IP', key: 'machineIp', type: 'text', orderable: true},
  
    {title: 'Ruolo', key: 'user-name', type: 'custom', orderable: false,
      render: (record:any) => {
        let data = JSON.parse(record.sessionData)
        return <>{data.name}</>
      }
      
    },
    {title: 'Ruolo', key: 'role', type: 'custom', orderable: false,
      render: (record:any) => {
        let data = JSON.parse(record.sessionData)
        return <>{data.roleText} ({data.role})</>
      }
      
    },
    {title: 'User Agent', key: 'userAgent', type: 'text', orderable: true},
    {title: 'OS', key: 'platform', type: 'text', orderable: true},
    {title: 'Data accesso', key: 'createdDtm', type: 'datetime', orderable: true},
  ]
  return (
    <>
      <CrudProvider api={api}>
        <ListComponent
          columns={columns}
          title={'Log accessi di ' + userName + ' (' + userUsername + ')'}
          filters={filters}
          newButton={false}
          defOrder="createdDtm"
          defOrderDir="desc"
          show_menu={false}
          otherButtons={[
            {
              type: 'link',
              to: '/user',
              title: 'Indietro',
              icon: 'fa-solid fa-arrow-left',
              color: 'warning',
            },
          ]}
        ></ListComponent>
      </CrudProvider>
    </>
  )
}
